import PRICES_FALLBACK from '../data/pricesFallback';

const ENDPOINT = 'https://parkingpyrzowice.info/phphandler/getPrices.php';
const CACHE_KEY = 'parking-prices-cache-v1';
const FETCH_TIMEOUT_MS = 8000;

const isValidPayload = (data) =>
    Array.isArray(data) && data.length > 0 && data.every((p) => p && Array.isArray(p.cenniki));

function readCache() {
    try {
        const raw = localStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!isValidPayload(parsed?.data)) return null;
        return parsed; // { data, ts }
    } catch {
        return null;
    }
}

function writeCache(data) {
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify({ data, ts: nowSafe() }));
    } catch {
        // brak localStorage / tryb prywatny -> ignoruj, działa bez cache
    }
}

// Date.now() opakowane, żeby brak API czasu nie wywalił modułu.
function nowSafe() {
    try {
        return Date.now();
    } catch {
        return 0;
    }
}

async function fetchFromApi() {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
    try {
        const res = await fetch(ENDPOINT, { signal: controller.signal, cache: 'no-store' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (!isValidPayload(data)) throw new Error('Nieprawidłowy format danych z API');
        return data;
    } finally {
        clearTimeout(timer);
    }
}

/**
 * Stale-while-revalidate: cache służy tylko do natychmiastowego renderu i jako
 * offline fallback — NIGDY nie blokuje świeżości.
 *
 * - Jest cache -> zwraca go od razu, a w tle pobiera świeże dane z API i po
 *   sukcesie woła onFresh(freshData) (jeśli różne od cache) + zapisuje cache.
 * - Brak cache -> czeka na API; gdy padnie -> nieświeży cache lub snapshot.
 *
 * Dzięki temu zmiana ceny w bazie widoczna po jednym odświeżeniu (~1s),
 * a strona i tak działa gdy API jest niedostępne.
 *
 * @param {(data:any[]) => void} [onFresh] callback z nowszymi danymi z API.
 */
export async function getPrices(onFresh) {
    const cache = readCache();

    const network = fetchFromApi()
        .then((data) => {
            writeCache(data);
            return data;
        })
        .catch(() => null);

    if (cache) {
        network.then((fresh) => {
            if (fresh && typeof onFresh === 'function') onFresh(fresh);
        });
        return cache.data;
    }

    const fresh = await network;
    return fresh ?? PRICES_FALLBACK;
}
